<div class="flex flex-column w-12 mx-0">
  <p-panel class="w-12 py-0" [toggleable]="true" [collapsed]="true">
    <ng-template pTemplate="header">
      <div class="text-center" style="width: 92%">
        <span class="my-0 font-weight-normal">Summary statistics</span>
      </div>
    </ng-template>
    <ng-template pTemplate="icons">
      <label
        class="p-panel-header-icon mb-0"
        pTooltip="Expand this section to inspect a table of statistics of the validation results."
        tooltipPosition="bottom"
      >
        <span class="pi pi-question-circle help-icon"></span>
      </label>
    </ng-template>
    @if (table$ | async; as table) {
      <div class="pb-3">
        @if (table === "error file size") {
          <ng-template class="pb-3">
            This validation has resulted in a file whose size exceeds the
            maximum limit. For this reason, the statistics table cannot be
            generated on the fly.
          </ng-template>
        } @else {
          @if (settings$ | async; as settings) {
            <div class="pb-3 text-justify">
              The mean, median and standard deviation are calculated on the
              validation results aggregated by metric and dataset. The spatial
              reference dataset used is
              {{ (refDataset$ | async)?.pretty_name || "..." }} ({{
                (refDatasetVersion$ | async)?.short_name || "..."
              }}, {{ (refDatasetVariable$ | async)?.pretty_name || "..." }}).
              You can find formulas of each metric in
              <a
                [href]="
                  (settings && settings.length > 0
                    ? settings[0].sum_link
                    : '#') + '#page=22'
                "
                target="_blank"
                >chapter 4</a
              >
              of our user manual.
            </div>
          }
          <span [innerHtml]="table" class="lg:text-base text-sm"></span>
          <div class="d-flex justify-content-between align-items-center">
            <button
              pButton
              type="button"
              icon="pi pi-download"
              label="Download .csv table"
              class="btn-action-large"
              pTooltip="Download the table to a .csv file"
              [life]="globals.tooltipLifetime"
              (click)="getSummaryStatisticsAsCsv()"
            ></button>
          </div>
        }
      </div>
    } @else {
      <p class="lead text-muted">
        We could not fetch statistics. Please try again later or
        <a routerLink="/contact-us"> contact </a> our support team.
      </p>
    }
  </p-panel>
</div>
